import ErpDocumentList from "./list";


if (document.body.getAttribute("data-current-path") === "erp/documents") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ErpDocumentList();
    }
}